export const FERNIE_UNLOAD_GRACE_MS = 250;

const shouldIgnoreFernieUnload = (openedAt: number, now: number, graceMs: number = FERNIE_UNLOAD_GRACE_MS): boolean =>
	now - openedAt < graceMs;

export default shouldIgnoreFernieUnload;
